import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className="footer">&copy; 2024 Time to Program, Happy Coding</div>
  )
}

export default Footer;
